<template lang="pug">
v-btn.mr-2.my-1(v-bind='$attrs' variant='flat' :color='color' :tile='tile')
    v-icon.mr-2 {{ icon }}
    | {{ label }}
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ButtonIconLabeled',
    props: {
        icon: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            default: 'primary',
        },
        label: {
            type: String,
            required: true,
        },
        tile: {
            type: Boolean,
            default: true,
        },
        dataCy: {
            type: String,
            default: undefined,
        },
        dataCyIcon: {
            type: String,
            default: undefined,
        },
    },
});
</script>
